import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';
import { Router } from '@angular/router';
import { environment } from '../../environments/environment';
import { StorageService } from './storage.service';
import { SessionMonitorService } from '../security/session-monitor.service';
import { LoggedUserInfo } from '../models/LoggedUserInfo';
import { KeycloakService } from './keycloak.service';

@Injectable({
  providedIn: 'root'
})
export class InitAppService {


  constructor(
    private httpClient: HttpClient,
    private storageService: StorageService,
    private router: Router,

    private sessionMonitorService: SessionMonitorService) { }


  initApp(): Observable<any> {

    return this.httpClient.get<LoggedUserInfo>(environment.apiUrl + "init-app")
      .pipe(map((loggedUser: LoggedUserInfo) => {

        // Il BE ritorna null quando l'utente non ha un ruolo abilitato all'app:
        // non attiviamo la sessione e mostriamo la pagina di cortesia.
        if (!loggedUser) {
          this.storageService.logout();
          this.sessionMonitorService.setSessionActive(false);
          this.router.navigate(['/no-access']);
          return null;
        }

        this.storageService.saveLoggedUser(loggedUser);
        this.sessionMonitorService.setSessionActive(true);
        return loggedUser;

      }));
  }


  logout(): void {
    this.storageService.logout(); 
    this.sessionMonitorService.setSessionActive(false);

  }

  sessionExpired() {
    this.storageService.logout();
    this.sessionMonitorService.setSessionActive(false);
  }


}  